var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJuno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 28,
    viewBox: "0 0 52 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5fcba4b18b7b95a0dbf66fa5_Juno_xmas_logo2 2",
    clipPath: "url(#clip0_669_11315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.2634 6.20715C26.3136 6.20715 24.3672 8.18212 23.6849 11.773C23.6849 11.8328 23.6448 11.8528 23.5846 11.8528C23.5244 11.8528 23.5043 11.7929 23.5043 11.753V6.52634H19.5512V15.2242C19.4308 17.7178 18.3472 19.4135 16.0194 19.4135C13.4108 19.4135 12.5278 17.8176 12.5278 15.2441V6.52634H8.57471V16.5009C8.57471 20.2514 10.4409 22.745 13.9927 22.745C16.9024 22.745 18.7284 20.7501 19.3706 17.239C19.3706 17.1792 19.4107 17.1393 19.4709 17.1592C19.511 17.1592 19.5512 17.2191 19.5512 17.259V22.366H23.5244V13.6482C23.6849 11.1944 24.8287 9.53866 27.1364 9.53866C29.745 9.53866 30.7082 11.1346 30.7082 13.708V22.3061L34.6614 22.346V12.4512C34.6413 8.7008 32.7952 6.20715 29.2634 6.20715Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.425 0.621216C6.72933 0.621216 7.79287 1.73837 7.79287 3.09491C7.79287 4.4714 6.72933 5.56861 5.425 5.56861C4.12066 5.56861 3.05713 4.45146 3.05713 3.09491C3.05713 1.73837 4.12066 0.621216 5.425 0.621216Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.29159 6.51184H3.49899L3.49899 23.0497C3.49899 23.5285 3.41872 23.9075 3.21805 24.127C2.99732 24.3863 2.69632 24.5259 2.35519 24.5259C1.99399 24.5259 1.65285 24.486 1.33179 24.1669C1.25152 24.0671 1.21139 24.0073 1.15119 24.0073C1.05085 24.0073 0.95052 24.0871 0.89032 24.2666C0.83012 24.4262 0.789986 24.5858 0.789986 24.7653C0.749853 25.5234 1.07092 26.1418 1.63279 26.6206C2.19465 27.1193 2.93712 27.3587 3.82005 27.3587C4.96385 27.3587 5.82672 26.9996 6.40865 26.2615C6.99059 25.5234 7.29159 24.4461 7.29159 22.9899L7.29159 6.51184C7.31165 6.51184 7.29159 6.51184 7.29159 6.51184Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M45.318 20.4248C44.1341 20.8437 42.9903 20.7839 41.8666 19.2278C41.2846 18.4298 40.5422 16.6544 40.181 15.5372C39.8198 14.4201 39.4184 12.5249 39.4184 11.5075C39.4184 9.55247 40.3214 8.7944 41.5054 8.37547C42.6893 7.95654 43.8331 8.01639 44.9568 9.57242C45.5388 10.3704 46.2812 12.1259 46.6424 13.263C47.0036 14.4001 47.405 16.2753 47.405 17.2927C47.405 19.2478 46.502 20.0058 45.318 20.4248ZM43.4117 6.12122C39.0372 6.12122 35.4854 9.83176 35.4854 14.4201C35.4854 19.0084 39.0372 22.7389 43.4117 22.7389C47.7862 22.7389 51.338 19.0283 51.338 14.44C51.338 9.85171 47.7862 6.12122 43.4117 6.12122Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_669_11315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.5044,
    height: 26.864,
    fill: "white",
    transform: "translate(0.790039 0.49231)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuno);
export default __webpack_public_path__ + "static/media/juno.3716b7178c0d85eafba9f570186c2dfd.svg";
export { ForwardRef as ReactComponent };